module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inputs inputs--budget-calculation"
  }, [_c('p', [_vm._v("Estimer votre budget de communication en fonction de votre chiffre d'affaire prévisionnel")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "ca-input"
    }
  }, [_vm._v("CA previsionnel")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ca),
      expression: "ca"
    }],
    staticClass: "form-control",
    class: {
      'is-wrong': _vm.isWrongClass
    },
    attrs: {
      "type": "number",
      "id": "ca-input",
      "name": "ca"
    },
    domProps: {
      "value": (_vm.ca)
    },
    on: {
      "focus": function($event) {
        _vm.isWrongClass = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ca = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v("€")])])])]), _vm._v(" "), _c('input', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "type": "submit",
      "value": "Je calcule"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-58bfb608!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/budget/BudgetCalculation.vue
// module id = 51
// module chunks = 0